<template>
  <video class="k-video" :poster="image" :image="image"  oncontextmenu="return false" controls  webkit-playsinline playsinline x5-playsinline  x-webkit-airplay="allow" controlslist="nodownload noremoteplayback"></video>
</template>

<script>
  // eventTester("loadstart");    //客户端开始请求数据
  // eventTester("progress");    //客户端正在请求数据
  // eventTester("suspend");        //延迟下载
  // eventTester("abort");        //客户端主动终止下载（不是因为错误引起），
  // eventTester("error");        //请求数据时遇到错误
  // eventTester("stalled");        //网速失速
  // // eventTester("play");        //play()和autoplay开始播放时触发
  // // eventTester("pause");        //pause()触发
  // eventTester("loadedmetadata");    //成功获取资源长度
  // eventTester("loadeddata");    //
  // eventTester("waiting");        //等待数据，并非错误
  // eventTester("playing");        //开始回放
  // eventTester("canplay");        //可以播放，但中途可能因为加载而暂停
  // eventTester("canplaythrough"); //可以播放，歌曲全部加载完毕
  // eventTester("seeking");        //寻找中
  // eventTester("seeked");        //寻找完毕
  // // eventTester("timeupdate");    //播放时间改变
  // eventTester("ended");        //播放结束
  // eventTester("ratechange");    //播放速率改变
  // eventTester("durationchange");    //资源长度改变
  // eventTester("volumechange");    //音量改变
  import {
    MEDIA_STATUS_NONE,
    MEDIA_STATUS_PLAYING,
    MEDIA_STATUS_PAUSED,
    MEDIA_STATUS_ENDED
  } from '../../const/media'
  export default {
    name: 'k-video',
    props: ['src', 'poster', 'toggle'],
    data() {
      return {
        // canplay: false,
        // canplaythrough: false,
        status: MEDIA_STATUS_NONE,
        time: 0, //currentTime
        second: 0,
        muted: false,
        volume: 1,
        duration: 0,
        hasInit: false,
        // playing: false,
        listeners: {}
      }
    },
    computed: {
      image() {
        return this.poster ? this.poster : ''
      },
      isPlaying() {
        return this.status === MEDIA_STATUS_PLAYING
        // return !!this.src && !!this.playing
      },
      // duration() {
      //   return this.$el ? this.$el.duration : 0
      // },
      // volume() {
      //   return this.valOf('volume', 0)
      // },
      currentSrc() {
        return this.valOf('currentSrc', '')
      },
      // currentTime() {
      //   return this.valOf('currentTime', 0)
      // },
      crossOrigin() {
        return this.valOf('crossOrigin', 0)
      }
    },
    methods: {
      valOf(name, defValue) {
        if (this.$el) {
          const v = this.$el[name]
          return v != null ? v : defValue
        }
        return defValue
      },

      // 播放
      play() {
        const {
          $el
        } = this
        if ($el) {
          $el.play()
        }
      },
      // 暂停
      pause() {
        const {
          $el
        } = this
        if ($el) {
          $el.pause()
        }
      },
      setStatus(status) {
        // 检测是否可设置
        this.status = status
      },
      setSrc(src) {
        const {
          isPlaying,
          $el
        } = this
        if ($el) {
          $el.src = src
          if (src && isPlaying) {
            // $el.play() 
            this.play()
          }
        }
      },
      on(evt, cb) {
        const self = this
        const {
          $el
        } = self
        if ($el) {
          const listeners = this.listeners || {}
          this.listeners = listeners

          const fn = typeof cb === 'function' ? cb : function () {
            self.emit(evt, cb)
          }
          listeners[evt] = fn
          $el.addEventListener(evt, fn)
        }
        return this
      },

      // 同步数据
      sync(name, attrName) {
        const {$el} = this
        if($el) {
          attrName = attrName || name 
          this[name] = $el[attrName]
        }
      },
      emit(type, args) {
        const {
          $el,
          time,
          muted,
          volume,
          second
        } = this
        // const duration = this.$el.duration

        let duration = 0

        // let muted = false
        if($el) {
          duration = $el.duration
          // muted = $el.muted // 是否静音
        }

        this.$emit(type, {
          type,
          duration,
          time,
          second,
          muted,
          volume,
          ...args
        })
      },
      init() {
        /*
        事件顺序：
        play -> loadstart -> loadedmetadata -> loadeddata -> canplay-> playing -> canplaythrough -> timeupdate -> ticking -> pause -> ended
        */
        if (!this.hasInit) {
          this.hasInit = true
          this.on('play', () => {
            this.sync('muted')
            this.sync('volume')
            this.setStatus(MEDIA_STATUS_PLAYING)
            this.emit('play')
          }).on('loadstart', () => {
            // this.sync('muted')
            this.emit('loadstart', {}) // 会影响后续 duration 值
          }).on('loadedmetadata', () => {
            this.emit('loadedmetadata')
          }).on('loadeddata', () => {
            this.emit('loadeddata')
          }).on('playing', () => {
            // this.sync('muted')
            this.setStatus(MEDIA_STATUS_PLAYING)
            this.emit('playing')
          }).on('timeupdate', () => {
            this.time = this.valOf('currentTime', 0)
          }).on('pause', () => {
            this.setStatus(MEDIA_STATUS_PAUSED)
            this.emit('pause')
          }).on('ended', () => {
            this.setStatus(MEDIA_STATUS_ENDED)
            this.emit('ended')
          }).on('waiting', () => {
            //   this.playing = false
            this.emit('waiting')
          }).on('abort', () => {
            // this.abort = true
            this.emit('abort')
          }).on('canplay', () => {
            //   this.canplay = true
            this.emit('canplay')
          }).on('canplaythrough', () => {
            //   this.canplaythrough = true
            this.emit('canplaythrough')
          }).on('volumechange', () => {
            this.sync('muted')
            this.sync('volume')
            this.emit('volumechange')
          })
        }
      }
    },
    watch: {
      src(src) {
        // this.src = src
        this.setSrc(src)
      },
      // canplay() {
      //   const {isPlaying} = this
      //   if (isPlaying) {
      //     this.play()
      //   }
      // },
      time(ms) {
        this.second = Math.ceil(ms)
      },
      second() {
        // console.log({secs})
        this.emit('ticking', {})
      },
      toggle(b) {
        if(b) {
          this.play()
        } else {
          this.pause()
        }
      }
    },
    mounted() {
      this.init()
      this.setSrc(this.src)
      if(this.toggle) {
        this.play()
      }
    },
    beforeDestroy() {
      const {
        listeners,
        $el
      } = this
      if ($el) {
        for (const evt in listeners) {
          if (listeners.hasOwnProperty(evt) && listeners[evt]) {
            $el.removeEventListener(evt, listeners[evt])
          }
        }
      }
    }
  }

</script>
